import React, { useRef, useEffect, useState } from "react";
import './LayoutLteBasic.css';

import { Link } from 'react-router-dom';
import AuthService from "services/auth.service";
import { useNavigate } from "react-router-dom";
import { useHistory } from 'react-router-dom';

import HeaderLteBasic from "./HeaderLteBasic";
import SidebarLte from "../adminLTE/SidebarLte";
import SidebarPlo from 'components/adminLte/SidebarPlo'

import InputBox from "components/InputBox";
import { Outlet } from "react-router-dom";
import logo0 from "assets/img/logo0.png";
import avatar2 from 'assets/images/avatar2.png';
import logoa0 from 'assets/images/logoa0.png';



// eslint-disable-next-line import/no-anonymous-default-export
export default () => {

    const [modalShow, setModalShow] = useState(false);
    const [input, setInput] = useState("");

    const [modalShow1, setModalShow1] = useState(false);
    const [input1, setInput1] = useState("");

    const navigate = useNavigate();
    
    //--------------para el timer---
    const [expirationDate, setExpirationDate] = useState("");
    let timer = useRef(null);
    let i=0;

    //---trabajo en el fondo
    useEffect (() => {
        //---- 60 seg * 60= 3600 segundos
        const expirationD = new Date(AuthService.getExpirationDate());
        console.log(expirationD);
        //----control de segundos antes de que se llegue al limite
        //const REFRESH_TOKEN_BUFFER = 1000*10;  //1000= 1seg   1000*10= 10 segundos
        const REFRESH_TOKEN_BUFFER = 1000*60*5;  //5 minutos antes
        const timeToRefreshToken = expirationD - Date.now() - REFRESH_TOKEN_BUFFER;
        console.log(timeToRefreshToken);
        
        if (timeToRefreshToken <= 0) {
            // server call to update app state with new token and new expirationDate
            refreshToken();
        } else {
            /*timer.current = setTimeout(() => {
                console.log("timer limit");
                refreshToken();
                timer.current = null;
            }, timeToRefreshToken); //se configura para que se ejectute en ese tiempo
            */
           const timeId = setInterval(()=>{
            console.log("timer limit");
            refreshToken();
            timer.current = null;
           },timeToRefreshToken);

           return ()=> clearInterval(timeId);
        }
    
        // clear the timeout and the timer ref on unmount
        //return ()=> clearTimeout(timer);
        
    }, [expirationDate]);
    //---------------------------------------------
    const refreshToken =async()=>{
        try {
            await AuthService.refreshToken().then(
              (response) => {
                
                if(response!=""){
                    setExpirationDate({"expirationDate": response});
                  
                }else{
                 //--correcto el registro  
                 navigate("/login");
                }
                //window.location.reload();
              },
              (error) => {
                console.log(error);
              }
            );
          } catch (err) {
            console.log(err);
        } 
    }
    
    //-----------------------------------
    const logout=(e)=>{
        e.preventDefault();
        //console.log("aqui estoy");
        AuthService.logout();
        navigate("/login");
        //let history = useHistory();
        //history.push("/login");
    }
    //---------- NUEVO ------------------
    //----------------INPUTBOX EDITAR (1) ---------------------
    const handleCancel=()=>{ setModalShow(false);   }
    const handleChange=(e)=>{setInput(e.target.value);  }
    //-----------------------------------------------------------
    return (
        <div>
            {/* wrapper */}
            <HeaderLteBasic  />
          
            <div className='mainWithSidebar'>
                
                <div className="contentPlo " style= {{ minHeight: "903px",marginLeft: "0px" }} >
                    <Outlet />
                </div>
            </div>
            

        </div>
    )
}